import { StyleSheet, Dimensions } from 'react-native';

export default StyleSheet.create({
  cardContainerStyle: theme => ({
    height: Dimensions.get('window').height,
    paddingVertical: 16,
    paddingHorizontal: 16,
    marginHorizontal: 2,
    marginTop: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    elevation: 2,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
  }),
});
